import react, { useEffect, useState } from 'react';
import config from '../../config/config';
import Header from '../directives/header';
import { Container, Row, Col, Button, Card, Form } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import Footer from '../directives/footer';
import '../css/unitronixexplained.css';
import { getOurStrategyData } from '../../apis/apiAction';

const Ourstrategy = () => {
  const [BannerData, setBannerData] = useState([]);


  useEffect(() => {
    getBannerData();
  }, []);

  const getBannerData = async () => {
    try {
      let res = await getOurStrategyData()
      if (res.data) {
        setBannerData(res.data);
      }
    } catch (error) {
      console.error("Error fetching banner data:", error);
    }
  };


  return (
    <>
      <Header />
      <main style={{ paddingTop: '80px' }}>
        <section className="unitronixexplained position-relative">
          <Container className="">
            <Row className="">
              <Col lg={6} className="">
                <div className="heading mb-4">
                  <h1 className="text-white text-uppercase fw-bold mb-0">
                    Our Strategy
                  </h1>
                </div>
                <p className="mb-4">
                  {BannerData.description}
                </p>
              </Col>
              <Col lg={6} className="mb-4">
                <div className="px-lg-5">
                  <div>
                    <img src="assets/images/ourstrategy.svg" width={`100%`} />
                  </div>
                </div>
              </Col>
            </Row>
          </Container>
        </section>

        <section className="corevalue py-0">
          <Container>
            <Row>
              <Col lg={12} className="mb-5">
                <div className="text-center">
                  <div className="">
                    <h1 className="my-2 text-white">These solutions deliver</h1>
                  </div>
                </div>
              </Col>
              <Col lg={12} className="">
                <Row>
                  <Col lg={6} className="mb-5">
                    <Card className="">
                      <Card.Body className="p-0">
                        <div className="d-flex">
                          <div className="blueBox">
                            <img src="assets/images/icon/bulb.png" />
                          </div>
                          <div className="p-4 pt-0 z-1">
                            <h4 className="text-white">
                              Simplicity and Accessibility
                            </h4>
                            <p>
                              {BannerData.simplicityDescription}
                            </p>
                          </div>
                        </div>
                      </Card.Body>
                    </Card>
                  </Col>
                  <Col lg={6} className="mb-5">
                    <Card className="">
                      <Card.Body className="p-0">
                        <div className="d-flex">
                          <div className="blueBox">
                            <img src="assets/images/icon/transparent.png" />
                          </div>
                          <div className="p-4 pt-0 z-1">
                            <h4 className="text-white">
                              Comprehensive Portfolio Allocation
                            </h4>
                            <p>
                            {BannerData.portfolioDescription}
                            </p>
                          </div>
                        </div>
                      </Card.Body>
                    </Card>
                  </Col>
                  <Col lg={6} className="mb-5">
                    <Card className="">
                      <Card.Body className="p-0">
                        <div className="d-flex">
                          <div className="blueBox">
                            <img src="assets/images/icon/accessibility.png" />
                          </div>
                          <div className="p-4 pt-0 z-1">
                            <h4 className="text-white">Scalable Technology</h4>
                            <p>
                              {' '}
                              {BannerData.technologyDescription}

                            </p>
                          </div>
                        </div>
                      </Card.Body>
                    </Card>
                  </Col>
                  <Col lg={6} className="mb-5">
                    <Card className="">
                      <Card.Body className="p-0">
                        <div className="d-flex">
                          <div className="blueBox">
                            <img src="assets/images/icon/security.png" />
                          </div>
                          <div className="p-4 pt-0 z-1">
                            <h4 className="text-white">
                              Decentralized Automation
                            </h4>
                            <p>
                              {' '}
                              {BannerData.automationDescription}

                            </p>
                          </div>
                        </div>
                      </Card.Body>
                    </Card>
                  </Col>
                </Row>
              </Col>
            </Row>
          </Container>
        </section>
        <section className="testionial position-relative mb-5">
          <Container>
            <Row className="justify-content-center">
              <Col lg={8} className="mb-5">
                <div className="testimonialBox">
                  <Card className="rounded-4 p-4 border border-primary">
                    <div className="quote quoteBlue">
                      <img src="assets/images/icon/upqoute.svg" />
                    </div>

                    <Card.Body className="">
                      <div className="w-100 text-center">
                        <div className="mb-0">
                          <p className="">
                            {BannerData.quote}
                          </p>
                        </div>
                      </div>
                    </Card.Body>
                    <div
                      className="quote quoteGreen"
                      style={{ bottom: '-25px' }}
                    >
                      <img src="assets/images/icon/downquote.svg" />
                    </div>
                  </Card>
                </div>
                <hr className="testimonialLine border-primary" />
              </Col>
            </Row>
          </Container>
        </section>
      </main>

      <Footer />
    </>
  );
};
export default Ourstrategy;
